<template>
  <div class="row mt-5 px-5">
    <div class="col-sm-4">
      <div
        class="form-group"
        :class="{
          'has-error has-feedback': legalName && !legalNameValid,
          'has-success has-feedback': legalNameValid,
        }"
      >
        <input v-model="legalName" type="text" class="form-control" id="legal-name" name="legal-name" />

        <span
          v-if="legalName"
          :class="{
            'glyphicon-ok': legalNameValid,
            'glyphicon-remove': !legalNameValid,
          }"
          class="glyphicon form-control-feedback"
        ></span>

        <span v-if="legalName && !legalNameValid" class="help-block">
          Type "{{ user.first_name }} {{ user.last_name }}" here
        </span>
      </div>
    </div>
    <div class="col-sm-8">
      <p>
        <b>Please sign by typing your full legal name in the box.</b>
      </p>
      <p>
        The individual whose name appears represents and warrants to have full authority to sign and execute this
        Agreement on their own behalf or on behalf of the party who is the intended user.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'signature-form',
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
      legalName: '',
    };
  },
  computed: {
    legalNameValid() {
      return this.legalName.length > 0;
    },
  },
  watch: {
    legalNameValid(valid) {
      this.$emit('validity-change', valid);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control-feedback {
  visibility: visible;
}
</style>
